module.exports = __webpack_public_path__ + "static/stylishkombitours-03d4b737a26f733409da012fa03e60e9.png";